'use strict'
import serviceBase from './serviceBase'
const reserveNowApi = {
    webLeadQuotes: (data) => serviceBase.post('/mysuiteamerica-reserve/api/WebLeadQuotes', data),
}
export default reserveNowApi